import { useContext } from "react"
import styles from "./styles.module.scss"
import { Wrapper, Page, Hyper, Fade } from "components"
import cn from "clsx"
import { Spacer } from "./Spacer"
import { SocialLink } from "./SocialLink" 
import type { FC, HTMLAttributes } from "react"


interface SectionProps
extends HTMLAttributes<HTMLDivElement> {}

const EMAIL_SUBJECT = encodeURI('[From:Website] I would like to connect')


export const Section: FC<SectionProps> = ({ children, className, ...props }) => {
  const { content } = useContext(Page.Context)

  return (
    <footer {...props} className={cn(styles.footer, className)} id="contact">
      <Wrapper>
        <Fade>
          <Page.Section.SubHeading>
            {content.contactsSubheading}
          </Page.Section.SubHeading>
          <Page.Section.Heading>
            {content.contactsHeading}
          </Page.Section.Heading>
          <Page.Section.Delimiter />
          <Page.Section.Description shrink
            className={styles.description}
            content={content.contactsDescription}>
            <Hyper.Link className={styles.link} type="bordered"
              itemProp="email"
              href={`mailto:${content.email}?subject=${EMAIL_SUBJECT}`}
              target="_blank" 
              rel="nofollow">
              Say Hello!
            </Hyper.Link>
          </Page.Section.Description>
        </Fade>
        <div className={cn(styles.side, styles.left)}>
          <Spacer />
          <ul className={styles.sociaLinks}>
            {content.socialLinks.map((link, index) => (
              <SocialLink key={index} {...link} />
            ))}
          </ul>
        </div>
        <div className={cn(styles.side, styles.right)}>
          <Spacer />
          <Hyper.Link className={styles.email} 
            href={`mailto:${content.email}`}
            target="_blank" 
            rel="nofollow">
            {content.email}
          </Hyper.Link>
        </div>
        <div className={styles.copyright}>
          Designed & developed by Pavló Valor
        </div>
      </Wrapper>
    </footer>
  )
}
